/**
 * Utility functions for permission handling
 */

import { PERMISSIONS_STORAGE_KEY } from "../defaultPermissions";

/**
 * Utility function to log the current content of localStorage for permissions
 */
export const debugLogStorageContent = () => {
  try {
    const storedPermissions = localStorage.getItem(PERMISSIONS_STORAGE_KEY);
    console.log("[DebugStorage] Current localStorage content:", {
      key: PERMISSIONS_STORAGE_KEY,
      value: storedPermissions ? JSON.parse(storedPermissions) : null
    });
  } catch (error) {
    console.error("[DebugStorage] Error logging storage content:", error);
  }
};

/**
 * Create a deep clone using structuredClone for maximum reliability
 */
export const deepClone = <T>(obj: T): T => {
  try {
    return structuredClone(obj);
  } catch (e) {
    // Fallback to JSON stringify/parse if structuredClone is not available
    return JSON.parse(JSON.stringify(obj));
  }
};

/**
 * Helper function to check if localStorage is available and working
 */
export const isLocalStorageAvailable = (): boolean => {
  try {
    const testKey = `test-${Date.now()}`;
    localStorage.setItem(testKey, testKey);
    const result = localStorage.getItem(testKey) === testKey;
    localStorage.removeItem(testKey);
    return result;
  } catch (e) {
    return false;
  }
};

